import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { EmailProviderCreateRequest, EmailProviderResponse, EmailProviderUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper, EnumToComboValues } from '../utils';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { EmailDetailsSectionHandler } from './details.section';
import { EmailProviderParametersSectionHandler } from './parameters.section';
import { HealthIssueService } from '../healthissues/healthissue.service';
import { DomSanitizer } from '@angular/platform-browser';

@RegisterEntityHandler('emailprovider')
@Injectable()
export class EmailProviderHandler extends EntityHandler<EmailProviderResponse> {

    constructor(
        admin: AdminEditorService,
        private issues: HealthIssueService,
        private sanitizer: DomSanitizer
    ) {
        super(admin);
    }

    states = ['active', 'suspended', 'deleted'];

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listEmailProviders/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listEmailProviders(ownerId, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'emailprovider',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.EMAILPROVIDER'),
        }));
    }

    getEntity(id: string): Promise<EmailProviderResponse> {
        return this.admin.getCached(`getEmailProvider/${id}`, api => api.entities.getEmailProvider(id), 10);
    }

    async createEntity(ownerId: string, entity: EmailProviderCreateRequest): Promise<EmailProviderResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createEmailProvider(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateEmailProvider(entity.id, { state: state as any }));
    }

    async getGridColumns(ownerId: string): Promise<IKuiTableCol[]> {
        const types = await this.admin.getCached(`listEmailProviderTypes/${ownerId}/0/100/name/null`, api => api.entities.listEmailProviderTypes(ownerId, 0, 100, 'name', null));
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.EMAILPROVIDER.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', ICONS.email),
            grid.IdNameComboColumn('type', 'TYPE', types.items.map(x => ({ id: x.id, value: x.name })), 100),
            grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
            grid.TimeAgoColumn('modifiedDate', 'MODIFIED'),
        ];
        return Promise.resolve(columns);
    }

    async getEditorSections(ownerId: string, entity: any): Promise<SectionHandlerGroup<EmailProviderResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new EmailDetailsSectionHandler(this.admin, ownerId, false),
                new EmailProviderParametersSectionHandler(this.admin, ownerId, false),
            ],
            warnings: entity ? (await this.issues.getIssuesForEntity(ownerId, entity.id, 1)).map(issue => {
                return this.sanitizer.bypassSecurityTrustHtml(`${issue.description}<br><a href="/#/admin/client/${entity.owner.id}/healthissues/grid/healthissue/${issue.id}">More</a>`);
            }) : [],
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: EmailProviderUpdateRequest, sections: FormSectionHandler<EmailProviderResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'emailprovider',
            entity: {}, // set up some defaults if you want
            sections: [
                new EmailDetailsSectionHandler(this.admin, ownerId, true),
                new EmailProviderParametersSectionHandler(this.admin, ownerId, true),
            ],
        });
    }

}












